export default [
    {
        path: 'relatorio-viagem-geral',
        component: () => import(
            /* webpackChunkName: 'transporte-paciente-relatorio-viagem-geral' */
            '@/views/transporte-paciente/relatorio-viagem-geral/Index'
        ),
        redirect: 'relatorio-viagem-geral/index',
        children: [
            {
                name: 'transporte-paciente-relatorio-viagem-geral-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'transporte-paciente-relatorio-viagem-geral' */
                    '@/views/transporte-paciente/relatorio-viagem-geral/List.vue'
                ),
            },
        ],
    },
]
